export const ANALYTICS_SET_ID = 'ANALYTICS_SET_ID';
export const ANALYTICS_SET_USER_PROPERTIES = 'ANALYTICS_SET_USER_PROPERTIES';
export const ANALYTICS_SEND_EVENT = 'ANALYTICS_SEND_EVENT';
export const GA_SEND_EVENT = 'GA_SEND_EVENT';
